import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

export interface AdminDeviceSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  'aria-label'?: string;
}

/**
 * Shared admin device search field (Devices list, OTA overrides lookup, etc.).
 */
export function AdminDeviceSearchInput({
  value,
  onChange,
  placeholder = 'Search by device ID, serial, name, owner, or MAC in metadata…',
  className = 'relative flex-1 max-w-md',
  inputClassName,
  'aria-label': ariaLabel = 'Search devices',
}: AdminDeviceSearchInputProps) {
  return (
    <div className={className}>
      <MagnifyingGlassIcon
        className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none"
        aria-hidden
      />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        className={
          inputClassName ??
          'w-full pl-10 pr-4 py-2 bg-slate-800/50 border border-slate-700 rounded-lg text-white placeholder-slate-400 focus:border-cyan-500 focus:outline-none'
        }
      />
    </div>
  );
}
